<template>
  <div>
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column
        label="标签序号"
        :resizable="false"
        width="180">
        <template slot-scope="{row}">
          {{ row.beginSetNo | tagCount() }} - {{ row.endSetNo | tagCount() }}
        </template>
      </el-table-column>
      <el-table-column
        :resizable="false"
        label="箱码数量"
        prop="setCount">
      </el-table-column>
      <el-table-column
        label="剩余数量"
        :resizable="false"
        prop="remainSetCount">
      </el-table-column>
      <el-table-column
        label="生产时间"
        :resizable="false"
        width="140">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat() }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :resizable="false"
        width="80">
        <template slot-scope="{row}">
          <el-button
            type="text"
            icon="el-icon-download"
            @click="downloadsetsegment(row)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="getsetassigns" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'LabelSetDetailModal',
  components: {},
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        isPreassign: 1
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  mounted() {
    this.getsetassigns()
  },
  methods: {
    downloadsetsegment(row) {
      this.loading = true
      this.$store.dispatch('label/downloadsetsegment', {
        payload: {
          setSegId: row.setSegId,
          setSegDetailsId: row.setSegDetailsId
        },
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getsetassigns() {
      this.loading = true
      this.$store.dispatch('label/getsetsegmentdetailses', {
        payload: {
          ... this.config,
          vendorId: this.userInfo.orgId
        },
        success: (res) => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.getsetassigns()
    }
  }
}
</script>
